import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeletePayload } from '../../../component/DashboardScreens/components/rbac.models';
import { environment } from '../../../../environments/environment';

/**
 * Generic CRUD base for the RBAC endpoints, which all share the same
 * REST shape on a single URL:
 *   POST   /Entity          -> add
 *   PUT    /Entity          -> update
 *   GET    /Entity?params   -> get / list
 *   DELETE /Entity  {id}    -> delete
 *
 * Extend this per entity and just set `endpoint`.
 */
@Injectable()
export abstract class RbacCrudService<TEntity, TGetParams = Record<string, any>> {
  protected abstract endpoint: string; // e.g. '/Role'
  apiBase:string = environment.apiURL
  constructor(
    protected http: HttpClient,
  ) {}

  protected get url(): string {
    return `${this.apiBase}${this.endpoint}`;
  }

  add(payload: Partial<TEntity>): Observable<any> {
    return this.http.post(this.url, payload);
  }

  update(payload: Partial<TEntity> & { id: string }): Observable<any> {
    return this.http.put(this.url, payload);
  }

  get(params?: TGetParams): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params as Record<string, any>).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get(this.url, { params: httpParams });
  }

  delete(id: string): Observable<any> {
    const payload: DeletePayload = { id };
    return this.http.request('delete', this.url, { body: payload });
  }
}
